<template>
  <div class="pc-page-settings__data-area">
    <div>
      <span>当前版本 {{version}}</span>
    </div>
    <div style="margin-top:2rem;">
      <el-button size="small" @click="goIssueHandler">意见反馈</el-button>
      <!-- <el-button size="small" style="margin-left: 1rem;">官方网站</el-button> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      version: 'version'
    })
  },
  methods: {
    goIssueHandler () {
      window.open('https://github.com/lowkeyfish/peacock-issues')
    }
  }
}
</script>

<style lang="scss">

</style>
